import logo from "../assets/images/waativalogo.png";
import config from "../devprodConfig";
import { Link, useNavigate } from "react-router-dom";
import { useUser } from "../context/UserContext";
import "../App.css";

import { can } from "../permissions/access";

import { PERMISSIONS } from "../permissions/permissions";
import { useState } from "react";

function Sidebar() {
  const { localUser, loading, logout } = useUser();
  const navigate = useNavigate();
  const API_URL = config.apiBaseUrl;

  const [mobileOpen, setMobileOpen] = useState(false);

  if (loading || !localUser) return null;

  const handleLogout = async () => {
    await fetch(`${API_URL}/auth/logout`, {
      method: "GET",
      credentials: "include",
    });

    
   document.body.classList.add("logging-out");

  setTimeout(() => {
    window.location.href = "/login";
  }, 300);
};


  const links = [
    { href: "/", label: "Haku", permission: PERMISSIONS.GENERAL.VIEW_SEARCH},
    { href: "/taloyhtiokortit", label: "Kortit", permission: PERMISSIONS.GENERAL.VIEW_TALOYHTIOKORTIT },
    { href: "/raportit", label: "Raportit"},
    // Admin-only for now (App.js's /valmislauseet route itself enforces
    // this via AdminRoute) — hidden here too so the link isn't visible to
    // people who'd just get bounced to /profile on clicking it. Drop
    // adminOnly once the feature is ready for non-admins; VIEW_TEMPLATES
    // stays as the permission to fall back to.
    { href: "/valmislauseet", label: "Valmislauseet", permission: PERMISSIONS.REPORTS.VIEW_TEMPLATES, adminOnly: true },
    { href: "/koho", label: "Koho", permission: PERMISSIONS.GENERAL.VIEW_KOHO },
    { href: "/sharepoint", label: "SharePoint" },
    { href: "/profile", label: "Omat tiedot" },
    { href: "/kayttajahallinta", label: "Hallinta" },
    // Tekstisuositukset (/tekstisuositukset) deliberately has no sidebar
    // entry — reached from the Kansilehti component's malliraportti section
    // instead (CoverPageForm.jsx), not top-level navigation. Route itself
    // (App.js) and permission gate are untouched.
    // Hidden before this push — not ready to show on dev yet even to users
    // who already have AI_GENERATE. Re-add this line to bring the tab back;
    // the route itself (App.js) and permission gate are untouched.
    // { href: "/llm-promptit", label: "LLM-promptit", permission: PERMISSIONS.REPORTS.AI_GENERATE },
  ];

  const bottomLinks = [
    { href: "/kehityslista", label: "Kehityslista", icon: "bi-kanban-fill", permission: PERMISSIONS.KEHITYSLISTA.VIEW },
  ];

  const allowedLinks = links.filter(link => {
    if (link.adminOnly && localUser.rooli !== "admin") return false;
    if (!link.permission) return true;
    return can(localUser, link.permission);
  });

  const allowedBottomLinks = bottomLinks.filter(link => {
    if (!link.permission) return true;
    return can(localUser, link.permission);
  });

  return (
    <>
      {/* Desktop Sidebar */}
      <nav
        className="d-none d-lg-flex flex-column bg-light border rounded shadow-sm p-2"
        style={{ position: "sticky", top: 0, height: "100vh", minWidth: 200 }}
      >


        <Link
          to="/taloyhtiokortit"
          className="d-flex align-items-center mb-3 text-dark text-decoration-none"
        >
          <img src={logo} width="30" height="30" alt="Logo" />
          <span className="fs-5 ms-3">WAATIVA</span>
        </Link>

        {/* Links */}
        <ul className="nav flex-column gap-2 mb-0" style={{ flexGrow: 1 }}>
          {allowedLinks.map((link) => (
            <li className="nav-item" key={link.href}>
              <Link to={link.href} className="btn btn-outline-success w-100">
                {link.label}
              </Link>
            </li>
          ))}
        </ul>

        {/* Bottom links (e.g. Kehityslista) */}
        {allowedBottomLinks.length > 0 && (
          <ul className="nav flex-column gap-2 mt-2 mb-0">
            {allowedBottomLinks.map((link) => (
              <li className="nav-item" key={link.href}>
                <Link to={link.href} className="btn btn-outline-success w-100">
                  {link.icon && <i className={`bi ${link.icon} me-2`} />}
                  {link.label}
                </Link>
              </li>
            ))}
          </ul>
        )}

        {/* Logout */}
        <button
          className="btn btn-danger w-100 mt-3"
          onClick={handleLogout}
        >
          Kirjaudu ulos
        </button>
      </nav>

      {/* Mobile Sidebar */}
      <nav className="d-lg-none bg-light border rounded shadow-sm p-2">
        {/* Header */}
        <div className="d-flex align-items-center justify-content-between">
          <Link
            to="/taloyhtiokortit"
            className="d-flex align-items-center text-dark text-decoration-none"
            onClick={() => setMobileOpen(false)}
          >
            <img src={logo} width="30" height="30" alt="Logo" />
            <span className="fs-5 ms-3">WAATIVA</span>
          </Link>

          <button
            className="btn btn-outline-secondary"
            onClick={() => setMobileOpen(!mobileOpen)}
            aria-label="Toggle menu"
          >
            ☰
          </button>
        </div>

        {/* Mobile links */}
        {mobileOpen && (
          <ul className="nav flex-column gap-2 mt-3 text-center">
            {allowedLinks.map((link) => (
              <li className="nav-item" key={link.href}>
                <Link
                  to={link.href}
                  className="btn btn-outline-success w-100"
                  onClick={() => setMobileOpen(false)}
                >
                  {link.label}
                </Link>
              </li>
            ))}

            {allowedBottomLinks.map((link) => (
              <li className="nav-item" key={link.href}>
                <Link
                  to={link.href}
                  className="btn btn-outline-success w-100"
                  onClick={() => setMobileOpen(false)}
                >
                  {link.icon && <i className={`bi ${link.icon} me-2`} />}
                  {link.label}
                </Link>
              </li>
            ))}

            <li className="nav-item">
              <button
                className="btn btn-danger w-100 mt-2"
                onClick={() => {
                  setMobileOpen(false);
                  handleLogout();
                }}
              >
                Kirjaudu ulos
              </button>
            </li>
          </ul>
        )}
      </nav>

    </>
  );
}

export default Sidebar;
